module.exports = __webpack_public_path__ + "img/btcmessage.72e982a4.png";